import { useEffect, useState } from "react";
import { Disclosure, Transition } from "@headlessui/react";
import styles from "./index.module.css";
import { MdOutlineChat, MdOutlineManageHistory } from "react-icons/md";
import { NavLink, useLocation } from "react-router-dom";
import { TiArrowSortedDown } from "react-icons/ti";
import { GiBackwardTime } from "react-icons/gi";
import ApiClient from "../../../methods/api/apiClient";
import { FaMapLocationDot } from "react-icons/fa6";
import { MdAdminPanelSettings } from "react-icons/md";
import { FaClipboardUser } from "react-icons/fa6";
import { TbMoneybag } from "react-icons/tb";
import { IoSettingsOutline } from "react-icons/io5";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { RxDashboard } from "react-icons/rx";
import environment from "../../../environment";
import { GrDocumentPerformance } from "react-icons/gr";
import { TbReport } from "react-icons/tb";
import { BsCardChecklist } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { count_success } from "../../../Pages/actions/count";
import socketModel from "../../../models/socketModel";

const Html = ({ ListItemLink, tabclass, isAllow, route, isOpen, user }) => {
  const [activeplan, setActiveplan] = useState();
  const role = user?.customerRole?.name === "Group Leader";
  const unReadCount = useSelector((state) => state?.count?.data)
  const dispatch = useDispatch()
  const getactivePlan = () => {
    let filter = {};
    if (user?.subRole?.id == environment.SubRolePartner) {
      filter = { id: user.id || user?._id };
    } else {
      filter = {};
    }
    ApiClient.get("api/getMyPlan", filter).then((res) => {
      if (res.success) {
        setActiveplan(res?.data);
      }
    });
  };

  const location = useLocation();
  useEffect(() => {
    if (user?.customerRole?.name === "Group Leader") {
      getactivePlan();
    }
    // socketModel.emit("unread-count", { senderId: user?._id || user?.id })
    // socketModel.on("unread-count-received", (response => {
    //   dispatch(count_success(response?.unreadCount));
    // }))
  }, []);

  const activecls = (tab) => {
    let url = window.location.href;
    let value = false;
    tab?.map((itm) => {
      if (url.includes(itm)) value = true;
    });
    return value;
  };

  const menus = [
    {
      name: "Dashboard",
      icon: (
        <RxDashboard className="w-[30px] h-[30px] p-[5px]" />
      ),
      activeIcon: (
        <RxDashboard className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/dashboard",
      key: "readDashboard",
    },
    {
      name: "Location",
      icon: <FaMapLocationDot className="w-[30px] h-[30px] p-[5px]" />,
      activeIcon: <FaMapLocationDot className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/location",
      key: "readLocation",
    },
    {
      name: "Sub Admin",
      icon: (
        <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px]" />
      ),
      activeIcon: (
        <MdAdminPanelSettings className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/subadmin",
      key: "readsubadmin",
    },
    {
      name: "Manager",
      icon: (
        <FaClipboardUser className="w-[30px] h-[30px] p-[5px]" />
      ),
      activeIcon: (
        <FaClipboardUser className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/manager",
      key: "readManager",
    },
    {
      name: "Staff",
      icon: (
        <HiOutlineUserGroup className="w-[30px] h-[30px] p-[5px]" />
      ),
      activeIcon: (
        <HiOutlineUserGroup className="w-[30px] h-[30px] p-[5px] text-white" />
      ),
      url: "/staff",
      key: "readStaff",
    },
    {
      name: user?.role === "staff" ? "My Shifts" : "Shift Management",
      icon: <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <MdOutlineManageHistory className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/Shift",
      key: "readShift",
    },
    {
      name: "Attendance",
      icon: <BsCardChecklist className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <BsCardChecklist className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/attendance",
      key: "readattendance",
    },
    {
      name: "Budget",
      icon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <TbMoneybag className="w-[30px] h-[30px] p-[5px] text-white " />,
      url: "/budget",
      key: "readbudget",
    },
    {
      name: "Daily Report",
      icon: <TbReport className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <TbReport className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/dailyreport",
      key: "readdailyreport",
    },
    {
      name: "Performance",
      icon: <GrDocumentPerformance className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <GrDocumentPerformance className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/performance",
      key: "readperformance",
    },
    {
      name: "Chat",
      icon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <MdOutlineChat className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/chats",
      key: "readchats",
    },
    {
      name: "Global Settings",
      icon: <IoSettingsOutline className="w-[30px] h-[30px] p-[5px] " />,
      activeIcon: <IoSettingsOutline className="w-[30px] h-[30px] p-[5px] text-white" />,
      url: "/settings",
      key: "readsetting",
    },
    // {
    //   name: "Geo",
    //   icon: <IoGitMergeOutline className="text-[20px]" />,
    //   activeIcon: <IoGitMergeOutline className="text-[20px]" />,
    //   key:"readGeo",
    //   menu: [
    //     {
    //       name: "Continent",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/continent",
    //       key: "readGeo",
    //     },
    //     {
    //       name: "City",
    //       icon: <FiUsers className="text-[20px]" />,
    //       url: "/city",
    //       key: "readGeo",
    //     },
    //   ],
    // },

  ];

  return (
    <>
      <div
        className={`px-[12px]   sidebar-padding ${isOpen && styles.sm_sidebar}`}
        component="siderbar"
      >
        <ul className="space-y-2 ">
          {menus.map((itm) => {
            return (
              <>
                {itm.icon ? (
                  <>
                    <li>
                      {itm.menu ? (
                        <>
                          {isAllow(
                            itm.menu.map((itm) => itm.key).toString()
                          ) ? (
                            <>
                              <Disclosure
                                as="div"
                                defaultOpen={activecls(
                                  itm.menu.map((itm) => itm.url)
                                )}
                              >
                                {({ open }) => (
                                  <>
                                    <tooltip placement="right" title={itm.name}>
                                      <Disclosure.Button className="w-full p-4 rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 sidebar-drop">
                                        <span className="text-sm fow-full  rounded-md flex items-center justify-between gap-[12px] transition-all duration-300 font-normal text-inherit flex items-center gap-[12px] crm ">
                                          <span className="relative">
                                            {itm?.name == "Chat" && unReadCount > 0 && (<span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]">
                                            </span>)}
                                            {!open ? (
                                              <>{itm?.icon}</>
                                            ) : (
                                              <>{itm?.activeIcon}</>
                                            )}
                                          </span>
                                          <span className="text-inherit leading-none sidebar_text font-[500]">
                                            {itm.name}
                                          </span>
                                        </span>
                                        <TiArrowSortedDown
                                          className={`${open ? "" : "-rotate-90 transform"
                                            } h-3 w-3 transition-all duration-500`}
                                        />
                                      </Disclosure.Button>
                                    </tooltip>
                                    <Transition
                                      enter="transition duration-300 ease-in-out"
                                      enterFrom="transform scale-95 opacity-0"
                                      enterTo="transform scale-300 opacity-300"
                                      leave="transition duration-300 ease-in-out"
                                      leaveFrom="transform scale-300 opacity-300"
                                      leaveTo="transform scale-95 opacity-0"
                                    >
                                      <Disclosure.Panel className=" mt-[4px] ">
                                        <ul className="space-y-2">
                                          {itm.menu?.map((sitm) => {
                                            return (
                                              <>
                                                {isAllow(sitm.key) ? (
                                                  <li className="px-4">
                                                    {" "}
                                                    <NavLink
                                                      className={(isActive) =>
                                                        "p-4 rounded-md block text-sm font-normal text-[#333333] cursor-pointer !no-underline transition-all " +
                                                        (location?.pathname.includes(
                                                          sitm.url
                                                        ) &&
                                                          " !text-[#3C73AA] !bg-[#4d899247]  !font-medium")
                                                      }
                                                      to={sitm.url}
                                                    >
                                                      <div className="flex items-center relative ">
                                                        <span className="w-[7px] h-[7px] bg-[#596b77] rounded-full block absolute -left-[4px]"></span>
                                                        <span
                                                          className="text-inherit leading-none sidebar_text font-[500] ps-5"
                                                          title={sitm.name}
                                                        >
                                                          {sitm.name}
                                                        </span>
                                                      </div>
                                                    </NavLink>
                                                  </li>
                                                ) : null}
                                              </>
                                            );
                                          })}
                                        </ul>
                                      </Disclosure.Panel>
                                    </Transition>
                                  </>
                                )}
                              </Disclosure>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {isAllow(itm.key) ? (
                            <>
                              <tooltip
                                placement="top"
                                color="#3730ff"
                                title={itm.name}
                              >
                                <NavLink
                                  to={itm.url}
                                  className={(isActive) =>
                                    "ps-5 pe-2 py-2 rounded-xl flex items-center gap-[12px] text-sm font-[500] text-[#333333] hover:bg-[#3C73AA14] !no-underline transition-all " +
                                    (location?.pathname.includes(itm.url) &&
                                      " text-white !bg-[#3C73AA] !font-medium")
                                  }
                                >
                                  <span className="relative ">
                                    {itm?.name == "Chat" && unReadCount > 0 && (<span className="bg-[#3C73AA] flex items-center justify-center h-[15px] w-[15px] rounded-full text-white text-[8px] absolute top-[-6px] right-[-4px] leading-[0px]">
                                    </span>)}
                                    {!location?.pathname.includes(itm.url) ? (
                                      <>{itm.icon}</>
                                    ) : (
                                      <>{itm?.activeIcon}</>
                                    )}
                                  </span>

                                  <span className="text-inherit leading-none sidebar_text font-[500]">
                                    {itm.name}
                                  </span>
                                </NavLink>

                              </tooltip>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <h6
                        className={`${isOpen ? "py-[12px] " : "p-[12px]  text-md"
                          } text-xs font-medium text-[#7E8B99] mt-[12px]`}
                      >
                        <span className=" sidebar_text text-center">
                          {" "}
                          {itm.name}{" "}
                        </span>
                      </h6>
                    </li>
                  </>
                )}
              </>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Html;
